/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} School_Docenten_Errors_User_Is_Not_HoofddocentInputs */

const nl_school_docenten_errors_user_is_not_hoofddocent = /** @type {(inputs: School_Docenten_Errors_User_Is_Not_HoofddocentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alleen hoofddocenten kunnen dit aanpassen.`)
};

/**

* @param {School_Docenten_Errors_User_Is_Not_HoofddocentInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const school_docenten_errors_user_is_not_hoofddocent = /** @type {((inputs?: School_Docenten_Errors_User_Is_Not_HoofddocentInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<School_Docenten_Errors_User_Is_Not_HoofddocentInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_school_docenten_errors_user_is_not_hoofddocent(inputs)
});
export { school_docenten_errors_user_is_not_hoofddocent as "school.docenten.errors.user_is_not_hoofddocent" }